import {
    getISODateTime,
    getMonthDayShort,
    getMonthDayYear,
    getMonthDayYearTime,
    getTime,
    safeFromUnixTime,
    type TimeUnit,
} from '@liveauctioneers/hammer-ui-core/utils/dateTimeFormat';
import { isValid, parseISO } from 'date-fns';

export { safeFromUnixTime };
export type { TimeUnit };

export const formatMonthDayYear = (timestamp?: TimeUnit): string => getMonthDayYear(timestamp as TimeUnit);

export const shortFormatDate = (timestamp?: TimeUnit): string =>
    getMonthDayYear(timestamp as TimeUnit, { short: true });

export const longFormatDate = (timestamp?: TimeUnit): string =>
    getMonthDayYearTime(timestamp as TimeUnit, { short: true });

export const shortFormatDateYearless = (timestamp?: TimeUnit): string => getMonthDayShort(timestamp as TimeUnit);

export const timeOnlyDate = (timestamp?: TimeUnit): string => getTime(timestamp as TimeUnit);

export const formatHyphenatedDateOnly = (timestamp?: TimeUnit): string =>
    getISODateTime(timestamp as TimeUnit, { short: true });

export const formatArticleDate = (dateString?: string | null): string | null => {
    const parsedDate = dateString ? parseISO(dateString) : null;
    return parsedDate && isValid(parsedDate) ? getMonthDayYear(parsedDate) : null;
};
